// data/gallery.ts

export interface GalleryImage {
  id: string;
  src: string;
  alt: string;
  title: string;
  caption: string;
  category: string;
}

export const galleryImages: GalleryImage[] = [
  {
    id: "g1",
    src: "/gallery/brassv2.webp",
    alt: "Handcrafted brass decor",
    title: "Brass Collection",
    caption:
      "Premium handcrafted brass products created by skilled artisans with exceptional attention to detail.",
    category: "Brass",
  },
  {
    id: "g2",
    src: "/gallery/copperv2.webp",
    alt: "Elegant copper handicrafts",
    title: "Copper Collection",
    caption:
      "Beautiful copperware and decorative pieces combining timeless craftsmanship with modern elegance.",
    category: "Copper",
  },
  {
    id: "g3",
    src: "/gallery/woodv2.webp",
    alt: "Wooden handicrafts",
    title: "Wood Collection",
    caption:
      "Expertly carved wooden furniture and décor crafted from premium quality hardwoods.",
    category: "Wood",
  },
  {
    id: "g4",
    src: "/gallery/marblev2.webp",
    alt: "Luxury marble decor",
    title: "Marble Collection",
    caption:
      "Elegant marble creations showcasing refined artistry and luxurious finishing.",
    category: "Marble",
  },
  {
    id: "g5",
    src: "/gallery/aluminiumv2.webp",
    alt: "Aluminium decorative products",
    title: "Aluminium Collection",
    caption:
      "Contemporary aluminium décor and utility products designed for lasting beauty.",
    category: "Aluminium",
  },
  {
    id: "g6",
    src: "/gallery/homedecorv2.webp",
    alt: "Luxury home decor",
    title: "Home Decor",
    caption:
      "Curated home décor pieces that transform interiors with elegance and sophistication.",
    category: "Home Decor",
  },
  {
    id: "g7",
    src: "/gallery/furniturev2.webp",
    alt: "Premium handcrafted furniture",
    title: "Furniture Collection",
    caption:
      "Designer furniture crafted with precision to offer style, comfort, and durability.",
    category: "Furniture",
  },
  {
    id: "g8",
    src: "/gallery/lightv2.webp",
    alt: "Decorative lighting collection",
    title: "Lighting Collection",
    caption:
      "Statement lighting fixtures that blend artistic craftsmanship with functional design.",
    category: "Lighting",
  },
];